import { render, staticRenderFns } from "./UploadResource.vue?vue&type=template&id=5551ea28&scoped=true&"
import script from "./UploadResource.vue?vue&type=script&lang=js&"
export * from "./UploadResource.vue?vue&type=script&lang=js&"
import style0 from "./UploadResource.vue?vue&type=style&index=0&id=5551ea28&lang=scss&scoped=true&"
import style1 from "./UploadResource.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5551ea28",
  null
  
)

component.options.__file = "UploadResource.vue"
export default component.exports